module.exports = __webpack_public_path__ + "inputs/img/soz_logo1.24f754cc.svg";